export const minColumnWidthForm = '34rem';
